import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { PlacementsTable } from "./-pages/placementsTable";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/placements/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Placements", link: `/${datasetSlug}/data/placements` }]);
  return <PlacementsTable />;
}
